export default __webpack_public_path__ + "static/media/edit.8fc4226c.svg";